<template>
  <section
    class="contact-section"
    id="contact"
  >
    <div class="content">
      <div class="contact-header">
        <h1 class="title">{{ $t('message.contactTitle') }}</h1>
        <p>{{ $t('message.contactSubtitle') }}</p>
      </div>

      <div class="contact-grid">
        <div class="contact-social">
          <a
            href="https://wa.me/5591991707588"
            target="_blank"
            class="social-card whatsapp-highlight whatsapp-card"
          >
            <img
              src="@/assets/icons/icon-whatsapp-white-min.svg"
              alt="WhatsApp"
            />
            <div class="whatsapp-content">
              <h4>{{ $t('message.contactWhatsapp') }}</h4>
              <p>{{ $t('message.contactWhatsappText') }}</p>
            </div>
          </a>

          <a
            href="https://www.instagram.com/maia.tecnologia/"
            target="_blank"
            class="social-card"
          >
            <img
              src="@/assets/icons/icon-instagram-gradient-min.svg"
              alt="Instagram"
            />
            <span>{{ $t('message.contactInstagram') }}</span>
          </a>
          <a
            href="https://www.facebook.com/Maia.JanelaUnica/"
            target="_blank"
            class="social-card"
          >
            <img
              src="@/assets/icons/icon-facebook-gradient-min.svg"
              alt="Facebook"
            />
            <span>{{ $t('message.contactFacebook') }}</span>
          </a>
        </div>

        <div class="contact-info">
          <div class="info-block">
            <img
              src="@/assets/icons/icon-location-gradient-min.svg"
              alt="Location"
              class="contact-icon"
            />
            <h3>{{ $t('message.contactAddress') }}</h3>
            <p>{{ $t('message.contactAddressInfo') }}</p>
            <p>{{ $t('message.contactAddressInfo2') }}</p>
          </div>
          <div class="info-block">
            <img
              src="@/assets/icons/icon-mail-gradient-min.svg"
              alt="Email"
              class="contact-icon"
            />
            <h3>{{ $t('message.contactEmail') }}</h3>
            <a href="mailto:comercial@jufinanceiro.com">
              comercial@jufinanceiro.com
            </a>
            <a href="mailto:suporte@jufinanceiro.com">
              suporte@jufinanceiro.com
            </a>
          </div>
          <div class="info-block">
            <img
              src="@/assets/icons/icon-call-gradient-min.svg"
              alt="Phone"
              class="contact-icon"
            />
            <h3>{{ $t('message.contactPhone') }}</h3>
            <a href="tel:+559132763898">+55 (91) 3276-3898</a>
            <a href="tel:+5591991707588">+55 (91) 99170-7588</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.contact-section {
  padding: 60px 24px;
  background-color: var(--c5);
}
.contact-header {
  text-align: center;
  margin-bottom: 48px;
}
.contact-header .title {
  color: var(--c1);
}
.contact-header p {
  color: var(--c3);
  font-size: 1.1rem;
}
.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: start;
}
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.info-block {
  padding-left: 45px;
  position: relative;
}
.info-block h3 {
  color: var(--c1);
  margin-bottom: 8px;
}
.info-block p,
.info-block a {
  color: var(--c3);
  text-decoration: none;
  display: block;
  margin-bottom: 4px;
}
.info-block a:hover {
  color: var(--p2);
}
.contact-icon {
  position: absolute;
  left: 0;
  top: 5px;
  width: 30px;
}
.contact-social {
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.social-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border-radius: var(--radius-sm);
  background-color: var(--white);
  box-shadow: var(--shadow-sm);
  text-decoration: none;
  color: var(--c1);
  transition: transform 0.3s, box-shadow 0.3s;
}
.social-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}
.social-card img {
  width: 40px;
  height: 40px;
}
.social-card span {
  font-size: 1.2rem;
  font-weight: bold;
}
.whatsapp-highlight {
  background: linear-gradient(45deg, #25d366, #128c7e);
  color: var(--white);
}
.whatsapp-highlight:hover {
  background: linear-gradient(45deg, #128c7e, #25d366);
}
.whatsapp-highlight h4 {
  font-weight: bold;
  margin: 0;
}
.whatsapp-highlight p {
  margin: 0;
  opacity: 0.9;
}

@media (max-width: 992px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}
</style>
